import React from 'react';
import { Section } from './Section';

export function About({ bio }) {
  return (
    <Section id="about" title="About Me">
      <p className="about-text" style={{
        fontSize: '1.1rem',
        color: '#4b5563',
        lineHeight: '1.8',
        maxWidth: '800px',
      }}>
        {bio}
      </p>
    </Section>
  );
}
